// src/app/core/auth/oidc-auth.config.ts
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

export function getActiveAuthConfig(): OpenIdConfiguration {
  const config = ALL_OIDC_CONFIGS.find(
    (c) => c.configId === environment.authConfig
  );
  if (!config) {
    throw new Error(`OIDC config not found for ID "${environment.authConfig}"`);
  }
  
  console.log('Using OIDC config:', config);
  return config;
}

const ALL_OIDC_CONFIGS: OpenIdConfiguration[] = [
  {
    configId: 'embeddedClient-Config',
    authority: 'https://auth.staging.necta.supply',
    redirectUrl: `${window.location.origin}/necta-supply`,
    postLogoutRedirectUri: 'https://localhost:4200',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Debug,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    customParamsAuthRequest: {
      prompt: 'none',
    },
  },
  {
    configId: 'embeddedClient-Config-local-standalone',
    authority: 'https://auth.staging.necta.supply',
    redirectUrl: 'https://localhost:4201',
    postLogoutRedirectUri: 'https://localhost:4201',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  }, {
    configId: 'embeddedClient-Config-local',
    authority: 'https://localhost:4001',
    redirectUrl: `${window.location.origin}/necta-supply`,
    postLogoutRedirectUri: 'https://localhost:4200',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Debug,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    customParamsAuthRequest: {
      prompt: 'none',
    },
  },
  {
    configId: 'vcc-staging',
    authority: 'https://auth.staging.necta.supply',
    redirectUrl: `${window.location.origin}/necta-supply`,
    postLogoutRedirectUri: 'https://vcc.staging.necta.one',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Debug,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    customParamsAuthRequest: {
      prompt: 'none',
    },
  },
  {
    configId: 'vcc-staging-standalone',
    authority: 'https://auth.staging.necta.one',
    redirectUrl: 'https://vcc.staging.necta.one',
    postLogoutRedirectUri: 'https://vcc.staging.necta.one',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  },
  {
    configId: 'vcc-staging-supply-standalone',
    authority: 'https://auth.staging.necta.supply',
    redirectUrl: 'https://vcc.staging.necta.supply',
    postLogoutRedirectUri: 'https://vcc.staging.necta.supply',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  },
  {
    configId: 'vcc-local-standalone',
    authority: 'https://localhost:4001',
    redirectUrl: 'https://localhost:4201',
    postLogoutRedirectUri: 'https://localhost:4201',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  },
  {
    configId: 'kost-standalone',
    authority: 'https://auth.kost.local',
    redirectUrl: 'https://oasi.kost.local',
    postLogoutRedirectUri: 'https://oasi.kost.local',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  },
  {
    configId: 'demo-supply-standalone',
    authority: 'https://auth.demo.necta.one',
    redirectUrl: 'https://supply.demo.necta.one',
    postLogoutRedirectUri: 'https://supply.demo.necta.one',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
  }, {
    configId: 'demo-supply-embedded',
    authority: 'https://auth.demo.necta.one',
    redirectUrl: `${window.location.origin}/necta-supply`,
    postLogoutRedirectUri: 'https://demo.necta.one',
    clientId: 'vendorCatalogClient',
    scope: 'openid profile email offline_access vendorCatalogApi',
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    useRefreshToken: false,
    logLevel: LogLevel.Debug,
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    autoUserInfo: true,
    customParamsAuthRequest: {
      prompt: 'none',
    },
  }
];
